import { ApiService } from "../../../../constants/ApiService";
import { HttpService } from "../../../../constants/HTTPService";
import { IProfileApiHc } from "../../../../interfaces/IProfileApiHc";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getProfileSA = async (
  binusianID?: string,
  binusianName?: string,
  email?: string,
  businessUnit?: string,
  department?: string,
  title?: string,
  buLeaderName?: string,
  buLeaderBinusianID?: string,
  buLeaderEmail?: string,
  buLeaderTitle?: string,
  managerName?: string,
  managerBinusianID?: string,
  managerEmail?: string,
  managerTitle?: string,
  manager2ndLvlName?: string | null,
  manager2ndLvlBinusianID?: string | null,
  manager2ndLvlEmail?: string | null,
  manager2ndLvlTitle?: string | null
) => {
  const data = HttpService.post(
    ApiService.profileUser.getProfileSA,
    JSON.stringify({
      BinusianID: binusianID,
      BinusianName: binusianName,
      Email: email,
      BusinessUnit: businessUnit,
      Department: department,
      Title: title,
      BULeader: buLeaderName,
      BULeaderBinusianID: buLeaderBinusianID,
      BULeaderEmail: buLeaderEmail,
      BULeaderTitle: buLeaderTitle,
      Leader1: managerName,
      Leader1BinusianID: managerBinusianID,
      Leader1Email: managerEmail,
      Leader1Title: managerTitle,
      Leader2: manager2ndLvlName,
      Leader2BinusianID: manager2ndLvlBinusianID,
      Leader2Email: manager2ndLvlEmail,
      Leader2Title: manager2ndLvlTitle,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getProfileApiHc = async (
  profile?: IProfileApiHc,
  isByPass?: boolean,
  binusianID?: string
) => {
  const data = HttpService.post(
    ApiService.apiHc.getProfile,
    JSON.stringify({
      Profile: profile,
      IsByPass: isByPass,
      BinusianID: binusianID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getBuLeader = async (
  profile?: IProfileApiHc,
  isByPass?: boolean,
  binusianID?: string
) => {
  const data = HttpService.post(
    ApiService.apiHc.getBULeader,
    JSON.stringify({
      Profile: profile,
      IsByPass: isByPass,
      BinusianID: binusianID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getBuLeaderToken = async (
  profile?: IProfileApiHc,
  username?: string,
  password?: string
) => {
  const data = HttpService.post(
    ApiService.apiHc.getBULeader,
    JSON.stringify({
      Profile: profile,
      Username: username,
      Password: password,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getBuLeaderFRM = async (
  profile?: IProfileApiHc,
  isByPass?: boolean,
  binusianID?: string
) => {
  const data = HttpService.post(
    ApiService.apiFRM.getBULeader,
    JSON.stringify({
      Profile: profile,
      IsByPass: isByPass,
      BinusianID: binusianID,
    })
  );
  const dataAPI = (await data).data;
  return dataAPI.data.result;
};

export const getListPrivilegeByRole = async (email?: string) => {
  const data = HttpService.post(
    ApiService.masterRole.listPrivilegeByRole,
    JSON.stringify({
      Email: email,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getRoleNameProfileSA = async (binusianID?: string) => {
  const data = HttpService.post(
    ApiService.profileUser.getRoleNameProfileSA,
    JSON.stringify({
      BinusianID: binusianID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const byPassProfileSA = async (email?: string, password?: string) => {
  const data = HttpService.post(
    ApiService.profileUser.byPassProfileSA,
    JSON.stringify({
      Email: email,
      Password: password,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};
